import React, { useEffect, useState } from 'react';
import { Clock } from "lucide-react";
import { parseISO, format, formatDistanceStrict, differenceInSeconds } from "date-fns";
import { ptBR } from "date-fns/locale"; // adicione esta linha
var UpdateTime = React.memo(function (_a) {
    var lastUpdated = _a.lastUpdated, nextUpdate = _a.nextUpdate;
    var _b = useState(""), timeToNextUpdate = _b[0], setTimeToNextUpdate = _b[1];
    useEffect(function () {
        if (!nextUpdate)
            return;
        var interval = setInterval(function () {
            var now = new Date();
            var next = parseISO(nextUpdate);
            var diff = differenceInSeconds(next, now);
            if (diff > 0) {
                setTimeToNextUpdate(formatDistanceStrict(next, now, { locale: ptBR }));
            }
            else {
                setTimeToNextUpdate("Atualizando...");
            }
        }, 1000);
        return function () { return clearInterval(interval); };
    }, [nextUpdate]);
    return (React.createElement("span", { className: "flex items-center" },
        React.createElement(Clock, { className: "inline mr-1", size: 15 }),
        React.createElement("span", null,
            "\u00DAltima atualiza\u00E7\u00E3o:",
            " ",
            lastUpdated
                ? format(parseISO(lastUpdated), "dd/MM/yy HH:mm:ss")
                : "-",
            React.createElement("span", { className: 'hidden md:inline' },
                " | ",
                "Pr\u00F3xima em: ",
                timeToNextUpdate))));
});
export default UpdateTime;
